import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import zeplinColor from 'theme/Color';
import TaskCard from 'components/shared/CustomDashboard/Overview/Tasks/TaskCard/TaskCard';

const OpenTasksBox = ({ tasks, loading }: { tasks: any[]; loading?: boolean }) => (
  <Box
    sx={{
      backgroundColor: zeplinColor.Neutral2,
      border: `1px solid ${zeplinColor.Neutral5}`,
      borderRadius: '14px',
      padding: '16px',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      height: '260px',
      // flexShrink: 0,
    }}
  >
    <Typography variant='responsiveHeading4' color={zeplinColor.BasicBlack}>
      Open Tasks ({tasks.length})
    </Typography>
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        overflowY: 'auto',
        pr: '2px',
      }}
    >
      {loading ? (
        Array.from({ length: 3 }).map((_, i) => (
          <Skeleton key={i} variant='rounded' height={64} sx={{ borderRadius: '14px' }} />
        ))
      ) : tasks.length === 0 ? (
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <img src='/assets/no-chart.svg' width='32px' height='32px' alt='no-tasks' />
          <Typography variant='responsiveHeading3'>No Open Tasks</Typography>
          <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
            There are no open tasks right now.
          </Typography>
        </Box>
      ) : (
        tasks.map((task) => <TaskCard key={task.id} data={task} loading={false} />)
      )}
    </Box>
  </Box>
);

export default OpenTasksBox;
